import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAppNft } from '../store/appSlice';
import PremiumAnt from './images/ANT.png'; // Default image for premium ants
import BackButton from './BackButton';
import diamond from './images/Icon_Diamond.png';
import earned from './images/Icon_Earned.png';
import ConfirmSelection from './ConfirmSelection';

function LevelingAssign({ changeActiveComponent, goBack }) {
  const [selectedANTItem, setSelectedAntItem] = useState(null);
  const { nfts } = useSelector(selectAppNft);
  const [showConfirmSelection, setShowConfirmSelection] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [imageUri, setImageUri] = useState(null);

  const handleSelectButtonClick = () => {
    console.log("Selected ANT:", selectedANTItem); // Check if this logs the correct ANT
    setShowConfirmSelection(true);
  };

  const handleConfirmSelectionClose = () => {
    setShowConfirmSelection(false);
  };

  const handleANTItemClick = (ant) => {
    setSelectedAntItem(ant);
    setActiveItem(ant.mint); // Store the unique identifier for the Ant
    setImageUri(ant.metadata.image); // Store the image URI
};

  const formatMint = (mint) => {
    if (!mint) return '';
    return `${mint.substring(0, 10)}...${mint.substring(mint.length - 10)}`;
  };

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      alert('Address copied to clipboard!');
    }, (err) => {
      console.error('Failed to copy address', err);
    });
  };

  const getProgressPercentage = () => {
    if (selectedANTItem && selectedANTItem.remainPotions !== undefined && selectedANTItem.level !== undefined) {
      return (selectedANTItem.remainPotions / (selectedANTItem.level + 1)) *100;
    }
    return 0;  // Default to 0 if data is not sufficient
  };

  const progressPercentage = getProgressPercentage();

  return (
    <section id="nestwars-ants">
      <div className="newui-container">
        <div className="platform-container">
          <div className="inventory-container">
            <div className="inventory-container-left">
            <BackButton goBack={goBack} title={"BACK TO LEVELING"} />
              <div className="inventory-items">
                {nfts.map((nft, index) => {
                  const isPremium = nft.metadata.name.includes("Premium");
                  return (
                    <div
                      key={index}
                      className={`inventory-item ${isPremium ? "item-premium" : "item-basic"} ${activeItem === nft.mint ? "active9" : ""}`} // Highlight active Ant
                      onClick={() => handleANTItemClick(nft)}
                    >
                      <img src={nft.metadata.image} alt={nft.metadata.name} />
                      <div className="inventory-item-texts">
                        <p className="inventory-text">{nft.metadata.name}</p>
                        <p className="inventory-level-text">LVL:</p>
                        <p className="inventory-text">{nft.level}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {showConfirmSelection && (
              <ConfirmSelection
                onClose={handleConfirmSelectionClose}
                antInfo={{ mint: selectedANTItem.mint }} // Pass only the required data
                stakeFee={100}
                assignType="levelingGround"
                imageUri = {imageUri}
              />
            )}
            <div className="inventory-container-right">
              {selectedANTItem ? (
                <>
                  <div className="active-item-header-content-activity" id="ant-header-activity">
                    <div className="inventory-item-active-activity antonright-activity"><img src={selectedANTItem.metadata?.image || PremiumAnt} alt={selectedANTItem.name}/></div>
                    <div className="active-item-header-activity">
                      <h2>WORKER ANT</h2>
                      <p id="w-address" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(selectedANTItem.mint)}>{formatMint(selectedANTItem.mint)}</p>
                    </div>
                  </div>
                  <div className="level-bar-container" id="level-bar-leveling">
                  <div className="level-bar">
                    <div className="level-indicator">
                    LVL: <span className="bold-text">{selectedANTItem.level}</span>
                    </div>
                    <div className="exp-bar-container">
                      <div 
                        className="exp-bar" 
                        style={{ width: `${progressPercentage}%` }}
                      ></div>
                    </div>
                    <div className="exp-info">
                      EXP:<span className="bold-text"> {selectedANTItem.remainPotions}/{selectedANTItem.level+1}</span>
                    </div>
                  </div>
                  </div>
                  <div className="active-item-ant-container-activity2">
                    <div className="active-item-stats-activity-2"><h2>EXP RATE</h2><img src={diamond}></img><p>{48 - 0.5 * (selectedANTItem.level - 1)} hours</p></div>
                    <div className="active-item-stats-activity-2"><h2>ENTRY FEE</h2><img src={earned}></img><p>100 $ANTC</p></div>
                  </div>
              <div className="active-item-buttons-container-activity">
              <button className="active-item-button-lower" id="basic-ant-button-assign" onClick={handleSelectButtonClick}>ASSIGN ANT</button>
            </div>
                </>
              ) : (
                <h2 className="inventory-info-text">Choose an ANT to get more info</h2>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LevelingAssign;